import config from './config.js'
import store from '../store/index.js'
import axios from 'axios'

export default {
  ajax: function (p) {
    let obj = {
      cbSuccess: function () {},
      cbError: function () {},
      method: 'post',
      path: '',
      data: {},
      header: {},
      showLoading: function () {},
      hideLoading: function () {}
    }
    store().dispatch('getAuth')
    if (store().state.auth.status === 'in') {
      obj.header.Authorization = 'Bearer ' + store().getters.auth('jwt')
    }

    Object.assign(obj, p)
    obj.showLoading()

    let that = this
    axios({
      url: config.apiURI + obj.path,
      method: obj.method,
      data: obj.data,
      headers: obj.header
    }).then(function (res) {
      let data = res.data
      if (data.status === 200) {
        obj.cbSuccess(data)
      } else if (data.status === 400) {
        if (data.msg === 'auth_error') {
          store().dispatch('loginOut')
          store().dispatch('loginNeed')
        } else if (data.msg === 'auth_incorrect') {
          that.refreshJwt(p)
        } else if (data.msg === 'auth_denied' && store().state.status === 'out') {
          store().dispatch('loginNeed')
        } else {
          obj.cbError(data)
        }
      } else {
        obj.cbError({msg: 'unknown_error'})
      }
      obj.hideLoading()
    }).catch(function (error) {
      console.log(error)
      obj.hideLoading()
      // obj.cbError({msg: 'net_error' + obj.path})
    })
  },
  refreshJwt: function (p) {
    let uinfo = store().getters.auth('jwt_refresh')
    if (uinfo === null) {
      store().dispatch('loginOut')
      store().dispatch('loginNeed')
      return false
    }
    let that = this
    that.ajax({
      path: config.refreshJwt,
      method: 'get',
      header: {
        'Authorization': 'Bearer ' + uinfo
      },
      cbSuccess: function (res) {
        store().dispatch('updateAuth', {jwt: res.memo.jwt, jwt_refresh: res.memo.jwt_refresh})
        that.ajax(p)
      },
      cbError: function () {
        store().dispatch('loginOut')
        store().dispatch('loginNeed')
      }
    })
  },
  formatM: function (num) {
    return (num / 100).toFixed(2)
  },
  formatDate: function (odate, format) {
    let myDate = new Date(odate)
    let m = myDate.getMonth() + 1
    let d = myDate.getDate()
    let h = myDate.getHours()
    let i = myDate.getMinutes()
    let s = myDate.getSeconds()
    format = format.replace('yyyy', myDate.getFullYear())
    format = format.replace('mm', m < 10 ? ('0' + m) : m)
    format = format.replace('dd', d < 10 ? ('0' + d) : d)
    format = format.replace('hh', h < 10 ? ('0' + h) : h)
    format = format.replace('ii', i < 10 ? ('0' + i) : i)
    format = format.replace('ss', s < 10 ? ('0' + s) : s)
    return format
  },
  shareURI () {
    let shareWxLink = config.apiURI + 'uploaders/shareurl/?url='
    let url = window.location.href.split('#/')
    shareWxLink += url[1] ? encodeURIComponent(url[1]) : ''
    return shareWxLink
  },
  verify: {
    check: function (vdata) {
      for (let d in vdata) {
        let v = vdata[d]
        for (let r in v.rules) {
          let rdata = v.rules[r]
          if (this.rules['_' + r](v.val, rdata.args) === false) {
            return rdata.msg
          }
        }
      }
      return true
    },
    rules: {
      _required: function (val) {
        if (val !== '') {
          return true
        }
        return false
      },
      _email: function (val) {
        let p = /^[a-zA-Z0-9._%+-]+@(?!.*\.\..*)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
        return p.test(val)
      },
      _mobile: function (val) {
        let p = /^(13|14|15|16|17|18|19)\d{9}$/
        return p.test(val)
      },
      _alphanumeric: function (val) {
        let p = /^\w+$/
        return p.test(val)
      },
      _digits: function (val) {
        let p = /^[-,+]?\d+$/
        return p.test(val)
      },
      _number: function (val) {
        let p = /^[-,+]?\d+(\.\d+)?$/
        return p.test(val)
      },
      _equalTo: function (val, args) {
        if (val === args[0]) {
          return true
        }
        return false
      },
      _rangeLength: function (val, args) {
        if (val.length <= args[1] && val.length >= args[0]) {
          return true
        }
        return false
      },
      _equalLength: function (val, args) {
        if (val.length === args[0]) {
          return true
        }
        return false
      },
      _maxLength: function (val, args) {
        if (val.length <= args[0]) {
          return true
        }
        return false
      },
      _minLength: function (val, args) {
        if (val.length >= args[0]) {
          return true
        }
        return false
      },
      _date: function (val) {
        let p = /^(\d{4})-(0\d{1}|1[0-2])-(0\d{1}|[12]\d{1}|3[01])$/
        return p.test(val)
      }
    },
    addRule: function (name, fn) {
      this.rules['_' + name] = fn
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/g.js